export default {
    error: {
        abort_403_message: 'Access is denied. You may not have the appropriate permissions to access this page.',
        abort_403_text: 'No permission',
        abort_404_message: 'The page you are looking for might have been removed had its name changed or is temporarily unavailable.',
        abort_404_text: 'Page not found',
        something_went_wrong: 'Something went wrong!',
        required: {
            address_in_cambodia: 'Address is required',
            email: 'Email is required',
            first_name: 'First name is required',
            gender: 'Gender is required',
            identity_date: 'Identity Date is required',
            identity_image_back: 'Identity Image Back is required',
            identity_image_front: 'Identity Image Front is required',
            identity_issued_date: 'Identity Issued Date is required',
            identity_number: 'Identity Number is required',
            last_name: 'Last name is required',
            nationality: 'Nationality is required',
            passport_image_front: 'Passport Image Front is required',
            passport_image_back: 'Passport Image Back is required',
            passport_number: 'Passport Number is required',
            password: 'Password is required',
        },
        saving: 'Error Saving',
        vehicle_info_required: "Please fill in the required vehicle information.",
    },
    label: {
        about: "About Us",
        action: "Action",
        add: "Add",
        address: "Address",
        address_in_cambodia: "Address in Cambodia",
        admin_dashboard: "Admin Dashboard",
        agree_to: "I agree to the",
        all: "All",
        already_have_account: "Already have an account? Login.",
        amendment: "Amendment",
        amendment_date: "Request extend date",
        amendment_office: "Request change border gate",
        amount: "Amount",
        app_dashboard: "App Dashboard",
        app_name: "e-Customs",
        application: "Application",
        application_report: "Application Report",
        applications: "Applications",
        approve: "Approve",
        approve_changed_border_gate: "Approve changed border gate",
        approve_extended_date_of_entry: "Approve extended date of entry",
        approve_extended_date_of_exit: "Approve enxtended date of exit",
        asterisk: "Require",
        attachment: "Attachment",
        back: "Back",
        back_side: "Back side",
        between: "Between",
        border_pass_date: "Border Pass Issued Date",
        border_pass_number: "Border Pass Number",
        brand: "Brand",
        browse_your_device: "Browse your device",
        by_user: "by User",
        change_border_gate_of_entry: "Change border gate of entry",
        change_border_gate_of_exit: "Change border gate of exit",
        change_image: "Change image",
        changed_at: "Changed at",
        choose: "Choose",
        choose_document: "Choose File",
        choose_driver: "Choose Driver",
        choose_image: "Choose Image",
        choose_vehicle: "Choose Vehicle",
        city: "City",
        close: "Close",
        code: "Code",
        collapse: "Collapse",
        color: "Color",
        company_address: "Company Address",
        company_code: "Company Code",
        company_information: "Company Information",
        company_name: "Company Name",
        confirm: "Confirm",
        confirm_delete: "Are you sure you want to delete ?",
        confirm_password: "Confirm Password",
        contain: "Contain",
        create: "Create",
        create_application: "Create Application",
        created_at: "Created At",
        criteria: "Criteria",
        currency: "Currency",
        customs_registration: "Customs Registration",
        dashboard: "Dashboard",
        date: "Date",
        declaration: "Declaration",
        declaration_chart: "Declaration Chart",
        declaration_status: "My Applications",
        declaration_status_today: "My Applications today",
        declarations: "Declarations",
        decline: "Decline",
        decline_changed_border_gate: "Decline changed border gate",
        decline_extended_date_of_entry: "Decline extended date of entry",
        decline_extended_date_of_exit: "Decline extended date of exit",
        delete: "Delete",
        delete_success: "Delete Successful",
        deleted_at: "Deleted at",
        description: "Description",
        destination: "Destination",
        destination_assess: "Destination Assess",
        destination_change: "Destination Changed",
        destination_office_code: "Destination Office Code",
        destination_office_date: "Destination Date",
        destination_office_name: "Destination Office",
        destination_assess_status: "Destination assess status",
        document_size: "Document size must be less than or equal to 5MB.",
        dont_have: "Don't have",
        download: "Download",
        driver: "Driver",
        driver_information: "Driver / Captain Information",
        drivers: "Drivers",
        driving_license: "Driving Lisense",
        driving_license_image_back: "Driving Lisense Image Back",
        driving_license_image_front: "Driving Lisense Image Front",
        driving_license_photo: "Driving license's photo",
        edit: "Edit",
        email: "Email",
        empty_data: "No data to display",
        engine_number: "Engine Number",
        enrouting: "En-Routing",
        entry: "Entry",
        entry_date: "Entry Date",
        entry_office_code: "Entry Office Code",
        entry_office_name: "Entry Office Name",
        entry_vehicles: "Entry Vehicles",
        entry_vehicles_today: "Entry Vehicles Today",
        equal: "Equal",
        exit: "Exit",
        exit_date: "Exit Date",
        exit_office_code: "Exit Office Code",
        exit_office_name: "Exit Office Name",
        exit_vehicles: "Exit Vehicles",
        exit_vehicles_today: "Exit Vehicles Today",
        expand: "Expand",
        expired_date: "Expired Date",
        extended_date_of_entry: "Exdend date of entry",
        extended_date_of_exit: "Exdend date of exit",
        female: "Female",
        file_name: "File name",
        filter: "Filter",
        first_name: "First Name",
        forgot_password: "Forgot your password?",
        frame_number: "Chassis Number",
        fraud: "Fraud",
        from: "From",
        from_date: "From Date",
        front_side: "Front side",
        fullname: "Name",
        gender: "Gender",
        greater_than: "Greater Than",
        greater_than_or_equal: "Greater Than or Equal",
        guarantee_information: "Guarantee Information",
        guarantee_information_invalid: "Guarantee Information Invalid",
        have: "Have",
        having_passport: "Having Passport?",
        home: "Home",
        i_am_also_a_driver: "Are you a driver ?",
        i_am_also_driver: "I Am Also A Driver",
        id: "ID",
        identity_card: "Identity Card",
        identity_card_expired_date: "Identity Card Expired Date",
        identity_card_photo: "Identity card's photo",
        identity_date: "Identity Card Issued Date",
        identity_image_back: "Identity Image Back",
        identity_image_front: "Identity Image Front",
        identity_number: "Identity Card Number",
        image_back: "Image Back",
        image_front: "Image Front",
        image_size: "Image size must be less than or equal to 2MB.",
        input_information_invalid: "Input Information Invalid",
        insurance_company_code: "Insurance Company Code",
        insurance_company_name: "Insurance Company Name",
        insurance_date: "Insurance Date",
        insurance_number: "Insurance Number",
        is_required: "Is required",
        issued_date: "Issued Date",
        last_name: "Last Name",
        leave_page_subtitle: "you have unsaved changes!",
        leave_page_title: "Do you really want to leave?",
        length_of_stay: "Length of Stay",
        less_than: "Less Than",
        less_than_or_equal: "Less Than or Equal",
        list: "List",
        loading: "Retrieving Data ...",
        lodgement: "Lodgement",
        lodgement_assess: "Lodgement assess",
        lodgement_assess_approve: "Lodgement Office approval",
        lodgement_assess_reject: "Lodgement Office reject",
        lodgement_office_code: "Lodgement Office Code",
        lodgement_office_date: "Lodgement Date",
        lodgement_office_name: "Lodgement Office",
        lodgement_assess_status: "Lodgement assess status",
        login: "Login",
        login_description: "Sign in to start your session",
        login_information: "Login Information",
        male: "Male",
        months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
        more_info: "More info",
        my_profile: "My Profile",
        n0: "No.",
        name: "Name",
        nationality: "Nationality",
        next: "Next",
        no: "No",
        no_application: "You do not have application yet",
        no_data: "No data match your search",
        no_image: "No Image",
        no_overstay: "No overstay declarations",
        no_recently_declaration: "No Recently Declaration",
        not_equal: "Not Equal",
        number: "Number",
        office: "Office",
        office_code: "Office Code",
        officer: "Officer",
        ok: "OK",
        other: "Other Document",
        other_attachment_title: "Attachment file must be image type and size less than 5 MB.",
        other_document: "Other Document",
        other_file_criteria: "Allow file type: jpeg, png, jpg, pdf & Size: 10MB",
        other_information: "Other Information",
        over_stay_applications: "Overstay Declarations",
        overstay: "Overstay",
        owner: "Owner",
        owner_also_driver: "Owner is also a driver",
        owner_border_pass: "Owner Border Pass",
        owner_confirm: "Are you owner?",
        owner_information: "Owner Information",
        owner_passport: "Owner Passport",
        passport: "Passport",
        passport_date: "Passport Date",
        passport_expired_date: "Passport Expired Date",
        passport_image_back: "Passport Image Back",
        passport_issued_date: "Passport Issued Date",
        passport_number: "Passport Number",
        passport_photo: "Passport's photo",
        password: "Password",
        password_confirmation: "Password Confirmation",
        penalize: "Penalize",
        phone: "Phone",
        plate_number: "Plate Number",
        print: "Print",
        print_all: "All",
        print_declaration: "Declaration",
        print_conveyance_pass: "Conveyance Pass",
        profile: "Profile",
        qrcode: "Qr Code",
        reason: "Reason",
        receipt_number: "Receipt Number",
        recent_declaration: "Recent Declaration",
        register: "Register",
        register_date: "Register Date",
        register_new_account: "Register new account",
        register_number: "Register Number",
        register_type: "Register Type",
        register_year: "Register Year",
        reject: "Reject",
        reload: "Reload",
        remove: "Remove",
        report: "Report",
        request_change: "Request change",
        request_change_entry_date: "Request change entry date",
        request_change_entry_office: "Request change entry office",
        request_change_exit_date: "Request change exit date",
        request_change_exit_office: "Request change exit office",
        request_changed_border_gate: "Request change border gate",
        request_extended_date_of_entry: "Request extended date of Entry",
        request_extended_date_of_exit: "Request extended date of Exit",
        reset_password: "Reset your password",
        resolve: "Resolve",
        restore: "Restore",
        result: "Result",
        return_home: "Return Home",
        save: "Save",
        save_continue: "Save & Continue",
        scan: "Scan",
        search: "Search",
        search_application: "Search Application",
        search_driver: "Search Driver",
        search_not_found: "Application not found",
        search_vehicle: "Search Vehicle",
        security_returned: "This Guarantee is already returned",
        select: "Select",
        select_driver: "Please Select Driver",
        select_vehicle: "Please Select Vehicle",
        send: "Send",
        serial: "Serial",
        setting: "Setting",
        setup_my_profile: "Setup my profile",
        sign_in: "Sign In",
        size: "Size",
        status: "Status",
        steer: "Steering Wheel",
        submit: "Submit",
        temporary_export: "Temporary Out",
        temporary_import: "Temporary In",
        temporary_vehicle: "Temporary Vehicle",
        terms_conditions: "Terms & Conditions",
        timeline: "Timeline",
        to: "To",
        to_date: "To",
        today_entry: "Entry Today",
        today_exit: "Exit Today",
        total_declaration: "Total Declaration",
        total_vehicle: "Total Vehicle",
        type: "Type",
        update: "Update",
        update_profile: "Update Profile",
        updated_at: "Updated At",
        valid_from: "Valid From",
        valid_to: "Valid To",
        value_1: "Value#1",
        value_2: "Value#2",
        vehicle: "Vehicle",
        vehicle_and_driver: "Vehicle and Driver",
        vehicle_chart: "Vehicle Chart",
        vehicle_identitation_back: "Vehicle Identification Image Back",
        vehicle_identitation_front: "Vehicle Identification Image Front",
        vehicle_identity_photo: "Vehicle identity`s photo",
        vehicle_information: "Transport Mean / Vehicle Information",
        vehicle_report: "Vehicle Report",
        vehicle_type: "Vehicle Type",
        vehicles: "Vehicles",
        view: "View",
        view_attachment: "View Attachment",
        view_detail: "View Detail",
        view_document: "View Document",
        view_image: "View Image",
        year: "Year",
        yes: "Yes",
        your_email: "Your Email",
        your_information: "Your Information",
        your_password: "Your Password",
        zip: "Zip",
        pending: "Pending",
        edit_detail: "Edit Detail",
        owners: "Owners",
        search_owner: "Search Owner",
        choose_owner: "Choose Owner",
        select_owner: "Please Select Owner",
        declined: "Declined",
        destination_approved: 'Destination office approved',
        telegram: "Telegram",
        subscribe: "Subscribe",
        unsubscribe: "Unsubscribe",
    },
    message: {
        already_declaration: "Already declaration!",
        approve_amendment: "Do you want to approve this request?",
        choose_print_type: "Choose Print Type",
        click_to_view: "Click to view attachment",
        decline_amendment: "Do you want to decline this request?",
        instruction_info: "Please click on OK button system will take you to complete information.",
        no_driver: "You don't have drivers information yet!",
        no_result: "No result!",
        no_vehicle: "You don't have vehicles information yet!",
        not_update_passport: "You are not completed passport information yet!",
        not_update_profile: "You are not updated profile yet!",
        profile_completion_message: "Your profile is not completed for application yet. Please set up your profile!",
        profile_completion_title: "Attention!",
        profile_success: "Profile saved successfully!",
        required_if_no_identity_card: "This information will be required if no identity card insert",
        required_if_no_passport: "This information will be required if no passport insert",
        success: "Document saved successfully!",
        verify_phone: "We going to verify your account by this phone number, please make sure that it's correct.",
        please_complete_declaration_owner_first: 'Please complete owner information first!',
        owner_success: "Owner saved successfully!",
        driver_success: "Driver saved successfully!",
        vehicle_success: "Vehicle saved successfully!",
        are_you_sure: "Are you sure?",
    },
    validation: {
        attributes: {
            address: "Address",
            address_in_cambodia: "Address in cambodia",
            attachment: "attachment",
            border_pass_date: "Border Pass Date",
            border_pass_number: "Border Pass Number",
            owner_border_pass_number: "Border Pass Number",
            brand: "Brand",
            color: "Color",
            company_code_v1: "Company Code",
            destination_entry_date: "Entry Date",
            destination_entry_office_name: "Entry Office Name",
            destination_exit_date: "Exit Date",
            destination_exit_office_name: "Exit Office Name",
            destination_office_code_v1: "Destination Office Code",
            destination_office_date_v1: "Destination Office Date",
            destination_office_date_v2: "Destination Office Date",
            driver_address_in_cambodia: "Address In Cambodia",
            driver_border_pass_date: "Border Pass Date",
            driver_border_pass_number: "Border Pass Number",
            driver_first_name: "First Name",
            driver_gender: "Gender",
            driver_identity_card_number: "Identity card number",
            driver_identity_card_issued_date: "Identity card issued date",
            driver_identity_card_expired_date: "Identity card expired date",
            driver_last_name: "Last Name",
            driver_nationality: "Nationality",
            driver_passport_expired_date: "Passport Expired Date",
            driver_passport_issued_date: "Passport Issued Date",
            driver_passport_number: "passport number",
            driving_license_image_back: "Driving License Image Back",
            driving_license_image_front: "Driving License Image Front",
            engine_number: "Engine Number",
            entry_date: "Entry Date",
            entry_office_name: "Entry Office Name",
            exit_date: "Exit Date",
            exit_office_name: "Exit Office Name",
            first_name: "First Name",
            frame_number: "Chassis Number",
            fraud_code: "Fraud Code",
            fraud_name: "Fraud Name",
            fraud_valid_from: "Fraud Valid From",
            fraud_valid_to: "Fraud Valid To",
            from_date: "From Date",
            full_name: "fullname",
            fullname: "fullname",
            fullname_v1: "Full Name",
            gender: "Gender",
            gender_v1: "Gender",
            identity_date: "Identity Date",
            identity_date_expire: "Identity Date Expire",
            identity_image_back: "Identity Image Back",
            identity_image_front: "Identity Image Front",
            identity_number: "Identity Number",
            identity_v1: "Identity",
            insurance_company_code: "Insurance Company Code",
            insurance_company_name: "Insurance Company Name",
            insurance_date: "Insurance Date",
            insurance_number: "Insurance Number",
            last_name: "Last Name",
            lodgement_office_code_v1: "Lodgement Office Code",
            lodgement_office_date_v1: "Lodgement Office Date",
            lodgement_office_date_v2: "Lodgement Office Date",
            nationality: "Nationality",
            nationality_v1: "Nationality",
            office_code: "Office Code",
            other: "Other Document",
            owner_border_pass_date: "Border Pass Date",
            owner_border_pass_v1: "Owner Border Pass",
            owner_passport_number: "owner passport number",
            owner_passport_v1: "Owner Passport",
            passport_expired_date: "Passport Expired Date",
            passport_image_back: "Passport Image Back",
            passport_image_front: "Passport Image Front",
            passport_issued_date: "Passport Issued Date",
            passport_number: "Passport Number",
            passport_v1: "Passport",
            plate_number: "Plate Number",
            profile_address: "Address",
            profile_driving_license_image_back: "Driving Lisense Image Back",
            profile_driving_license_image_front: "Driving Lisense Image Front",
            profile_first_name: "First Name",
            profile_gender: "Gender",
            profile_identity_date: "Identity Date",
            profile_identity_date_expire: "Identity Date Expire",
            profile_identity_image_back: "Identity Image Back",
            profile_identity_image_front: "Identity Image Front",
            profile_identity_number: "Identity Number",
            profile_last_name: "Last Name",
            profile_nationality: "Nationality",
            profile_passport_image_back: "Passport Image Back",
            profile_passport_image_front: "Passport Image Front",
            register_type: "Register Type",
            registration_date_v1: "Registration Date",
            registration_date_v2: "Registration Date",
            registration_number: "Registration Number",
            registration_number_v1: "Registration Number",
            registration_number_v2: "Registration Number",
            registration_type: "Type",
            registration_type_v1: "Type",
            registration_year_v1: "Registration Year",
            registration_year_v2: "Registration Year",
            request_change_description: "request change description",
            request_change_description2: "request change description",
            security_date: "Security Date",
            security_number: "Receipt Number",
            security_office: "Security Office",
            security_serial: "Security Serial",
            steer: "Steering Wheel",
            to_date: "To Date",
            type: "Type",
            vehicle_type: "Type",
            verify_amend_description: "description",
            year: "Year"
        }
    }
}